import React from 'react';
import { Activation } from '../models/activation';
import ActivationStats from '../ActivationStats';
import ActivationSummary from '../ActivationSummary';
import ActivationSyncHistoryTable from '../ActivationSyncHistoryTable';

export interface ActivationSyncHistoryProps {
  activation: Activation;
}

export function ActivationSyncHistory(props) {
  return (
    <div>
      <ActivationSyncHistoryInner {...props} />
    </div>
  );
}

export function ActivationSyncHistoryInner({
  activation
}: ActivationSyncHistoryProps) {
  return (
    <div className='body-container'>
      <ActivationStats
        activation={activation}
      />

      <ActivationSummary
        activation={activation}
      />

      <ActivationSyncHistoryTable
        activationId={activation.id}
        activationSeqId={activation.seqId}
      />
    </div>
  );
}
